module.exports = __webpack_public_path__ + "static/media/mastercard.2bc44524.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mastercard.png
// module id = 213
// module chunks = 0